if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
            super.show(opener);

            setTimeout(function() {
              const color = $('input[name="Color"]:checked').val();
              $('input[name="Size"]').each(function(){
                let vari = color + ' / '+ $(this).val();
                const id = $(this).attr('id');
                vari = vari.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                const checkAvail = $('.vari-'+vari).val();
                
                if ($('.vari-'+vari).length) {
                  $('#label-'+id).show();
                  if (checkAvail == "false"){
                    $('#label-'+id).addClass('not-available');
                  } else {
                    $('#label-'+id).addClass('available');
                  }
                  $('.available:first').trigger('click');
                } else {
                  $('#label-'+id).hide();
                }
              });

              $('.color-value').text(color);
              $(".thumbnail-list__item").hide();

              let count = 1;
              $(".thumbnail-list__item").each(function(){
                const dotdata = $(this).data('alt');
                if (dotdata.indexOf(color) >= 0){
                  $(this).show();
                  $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("first-dots"+count);
                  $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("fill-dots");
                  $(this).addClass("first-dots"+count);
                  count += 1;
                }
              })

              const variant_color = $('input[name="Color"]:checked').val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
              const variant_size = $('input[name="Size"]:checked').val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
              const checked_id = "vari-"+variant_color+"-"+variant_size;
              
              if ($("."+checked_id).val() == "true"){
                $("#klaviyo__custom").removeClass("waitlist-block");
                $("#klaviyo__custom").addClass("waitlist-none");
                $("#klaviyo__custom").hide();
                $(".product-form__submit").show();
              } else {
                if($("#"+checked_id).val() == "false"){
                  $(".product-form__submit").hide();
                  $("#klaviyo__custom").show();
                  $("#klaviyo__custom").addClass("waitlist-block");
                  $("#klaviyo__custom").removeClass("waitlist-none");
                }
              }
            }, 0);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}